export const getFormattedPrice = ({ price, withCurrency = true }: { price?: number; withCurrency?: boolean }) =>
  (typeof price === 'number' && price.toFixed(2).toString().replace('.', ',') + (withCurrency ? ' €' : '')) || '';

export const getFormattedPercentage = (number: number): string =>
  (typeof number === 'number' && number.toFixed(0).toString() + '%') || '';
